(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-youtube-video') === undefined && !('YT_loading' in window)) {
        window['onYouTubeIframeAPIReady'] = function() {
            delete window['YT_loading'];
            const template = document.createElement('template');
            template.innerHTML = `
            <style>
            :host {
                display: inline-block;
                width: 560px;
                max-width: 100%;
                aspect-ratio: 560 / 315;
            }
            ::slotted(iframe) {
                width: 100%;
                height: 100%;
                border: 0;
                margin: 0;
            }
            </style>
            <slot></slot>
            `;
            customElements.define('base-youtube-video', class extends HTMLElement {
                constructor() {
                    super();
                    this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                }
                connectedCallback() {
                    this.insertAdjacentHTML('afterbegin', '<div></div>');

                    let autoplay = this.getAttribute('autoplay') ? this.getAttribute('autoplay') : 0;
                    let controls = this.getAttribute('controls') ? this.getAttribute('controls') : 0;
                    let rel = this.getAttribute('rel') ? this.getAttribute('rel') : 1;
                    
                    this.player = new YT.Player(this.querySelector('div'), {
                        width: '560',
                        height: '315',
                        host: 'https://www.youtube-nocookie.com',
                        videoId: this.getAttribute('video'),
                        playerVars: {
                            'autoplay': autoplay,
                            'controls': controls,
                            'rel': rel
                        },
                        events: {
                            onStateChange: (event) => {
                                clearTimeout(this.pauseTimeout);
                                if (event.data == YT.PlayerState.PLAYING) {
                                    this.dispatchEvent(new CustomEvent('play'));
                                } else if (event.data == YT.PlayerState.PAUSED) {
                                    // a dirty trick to avoid blending in and out the player icon too often
                                    // because youtube dispatches the paused event if the player stops playing because the user changed
                                    // the position on the video-track
                                    this.pauseTimeout = setTimeout(() => {
                                        this.dispatchEvent(new CustomEvent('pause'));
                                    }, 100);
                                } else if (event.data == YT.PlayerState.ENDED) {
                                    this.dispatchEvent(new CustomEvent('pause'));
                                }
                            }
                        }
                    });
                }
                play() {
                    this.player.playVideo();
                }
                pause() {
                    this.player.stopVideo();
                }
            });
        }
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
        window['YT_loading'] = 1;
    }
});
